import { useQuery } from '@tanstack/react-query';
import type { Portal } from '@bulk/types';
import type { PortalLookDto } from '@bulk/validation';
import { api } from '@/lib/api';

export interface HostGym {
  id: string;
  name: string;
  slug: string;
  status: string;
  memberSelfRegistration: boolean;
}

export interface HostContext {
  hostGym: HostGym | null;
  /** Which of the gym's addresses this is; PLATFORM for Bulk's own. */
  portal: Portal;
  signInByAddress: boolean;
  authenticated: boolean;
  /** The gym's design for the sign-in pages and member area, on a gym's own site address whose design opts in. */
  look: PortalLookDto | null;
}

export function useHostContext() {
  return useQuery({ queryKey: ['host-context', window.location.host], queryFn: () => api<HostContext>('/api/v1/auth/context'), staleTime: 5 * 60_000 });
}

/** The address rules in force here: `strict` when each person signs in only at their own address. */
export function useAddress(): { portal: Portal; strict: boolean; hostGymId: string | null } {
  const host = useHostContext().data;
  return { portal: host?.portal ?? 'PLATFORM', strict: host?.signInByAddress ?? false, hostGymId: host?.hostGym?.id ?? null };
}

/** Where a person lands after signing in: at a gym's staff address the admin app, on its site the member area, on Bulk's own the console. */
export function landingAt(portal: Portal): string {
  if (portal === 'SITE') return '/app';
  if (portal === 'PLATFORM') return '/platform';
  return '/admin';
}
